import { t } from "adapters/i18n";
import React from "react";
import CalculadoraCoordenadas from "../../../../../../lib/calculadoraCoordenadas";
import Tooltip from "../../Tooltip";
import {
  idsFarois,
  TipoFarois,
  stringSanidade,
} from "../../../../../../constants/idsFarois";
import _ from "lodash";
import moment from "moment";
import { MontaTextoTooltipCochoCompartilhado } from "./InfoCochoCompartilhado";
import { MontaTextoTooltipFezes } from "./InfoFezes";
import { MontaTextoTooltipNascimento } from "./InfoNascimentoMorte";
import { MontaTextoTooltipRebanho } from "./InfoRebanho";
import {
  getValueByType,
  tiposColetaAltura,
} from "features/manejo/views/MenuLateral/Farol/farolContainerUtils";

export const InfoFarol = (props) => {
  const {
    mouseOver,
    pasto,
    farolPasto,
    idFarolSelecionado,
    TipoIconeExibido,
    categoriasLotes,
    NomeForragem,
    TipoFarol,
    pastosComCochoCompartilhado,
    visualizarPontosColetas,
  } = props;

  if (mouseOver) {
    const position = CalculadoraCoordenadas.calcularCentroAlto(
      pasto.Coordenadas,
    );
    const textoToolTip = obterTextoToolTip(
      idFarolSelecionado,
      farolPasto,
      TipoIconeExibido,
      categoriasLotes,
      pasto,
      NomeForragem,
      TipoFarol,
      pastosComCochoCompartilhado,
    );
    return (
      <Tooltip
        Posicao={position}
        Texto={textoToolTip}
        visualizarPontosColetas={visualizarPontosColetas}
      />
    );
  } else {
    return null;
  }
};

const obterTextoToolTip = (
  idFarolSelecionado,
  farolPasto,
  TipoIconeExibido,
  categoriasLotes,
  pasto,
  NomeForragem,
  TipoFarol,
  pastosComCochoCompartilhado,
) => {
  let textoToolTip = pasto.NomeReduzido ? pasto.NomeReduzido : pasto.Nome;
  if (TipoFarois.Altura.includes(idFarolSelecionado)) {
    textoToolTip = montaTextoTooltipAlturaPasto(
      textoToolTip,
      NomeForragem,
      farolPasto,
      TipoIconeExibido,
    );
  } else if (TipoFarois.Sanidade.includes(idFarolSelecionado)) {
    textoToolTip = montaTextoTooltipSanidade(
      textoToolTip,
      farolPasto,
      categoriasLotes,
      idFarolSelecionado,
    );
  } else if (TipoFarois.Cocho.includes(idFarolSelecionado)) {
    textoToolTip = MontaTextoTooltipCochoCompartilhado(
      pastosComCochoCompartilhado,
      farolPasto,
      idFarolSelecionado,
      TipoFarol
    );
  } else if (idFarolSelecionado === idsFarois.rebanhoPresenca) {
    textoToolTip = MontaTextoTooltipRebanho(
      textoToolTip,
      farolPasto,
      categoriasLotes,
    );
  } else if (idFarolSelecionado === idsFarois.nascimentos) {
    textoToolTip = MontaTextoTooltipNascimento(textoToolTip, farolPasto);
  } else if (
    idFarolSelecionado === idsFarois.aguadaDisponibilidade ||
    idsFarois.aguadaQualidade
  ) {
    textoToolTip = montaTextoTooltipAguada(
      textoToolTip,
      pasto.NomeReduzido ? pasto.NomeReduzido : pasto.Nome,
      farolPasto,
    );
  }
  if (idFarolSelecionado === idsFarois.ganhoPeso) {
    textoToolTip += montaTextoTooltipGanhoPeso(farolPasto);
  }
  if (
    idFarolSelecionado === idsFarois.desabastecimento ||
    idFarolSelecionado === idsFarois.desabastecimentoCreep
  ) {
    textoToolTip = MontaTextoTooltipCochoCompartilhado(
      pastosComCochoCompartilhado,
      farolPasto,
      idFarolSelecionado,
    );
  }
  if (idFarolSelecionado === idsFarois.voltagem) {
    textoToolTip += montaTextoTooltipVoltagem(farolPasto);
  }

  if (idFarolSelecionado === idsFarois.fezes) {
    textoToolTip = MontaTextoTooltipFezes(textoToolTip, farolPasto);
  }
  if (idFarolSelecionado === idsFarois.entrevero) {
    textoToolTip += montaTextoTooltipEntreveiro(farolPasto);
  }

  return textoToolTip;
};

const montaTextoTooltipAlturaPasto = (
  textoToolTip,
  NomeForragem,
  farolPasto,
  TipoIconeExibido,
) => {
  if (farolPasto && farolPasto.Valor && farolPasto.Valor.Valor) {
    textoToolTip = textoToolTip + NomeForragem;
    if (
      farolPasto.Valor.Tipo === TipoIconeExibido ||
      TipoIconeExibido === "Todos"
    ) {
      textoToolTip = formataTextoToolTipAltura(
        farolPasto,
        textoToolTip,
        TipoIconeExibido,
      );
    }
  }
  return textoToolTip;
};

export const montaTextoTooltipAguada = (
  textoToolTip,
  NomePasto,
  farolPasto,
) => {
  if (typeof farolPasto === typeof undefined) {
    return (textoToolTip = NomePasto);
  } else {
    const dataColeta = farolPasto.DataDaColeta
      ? " \n " + t("common:date") + ": " + farolPasto.DataDaColeta
      : "";
    return (textoToolTip = textoToolTip + " \n" + dataColeta);
  }
};

const formataTextoToolTipAltura = (
  farolPasto,
  textoToolTip,
  TipoIconeExibido,
) => {
  const dataColeta = farolPasto.DataColeta
    ? " \n " +
      t("common:date") +
      ": " +
      new Date(farolPasto.DataColeta).toLocaleDateString()
    : "";
  const numeroTruncado = tranformaSeparacaoDoDecimalParaVirgula(
    Math.round(farolPasto.Valor.Valor) !== farolPasto.Valor.Valor
      ? farolPasto.Valor.Valor.toFixed(2)
      : farolPasto.Valor.Valor,
  );

  const tipoFarol =
    TipoIconeExibido === tiposColetaAltura.Todos
      ? `\n${getValueByType(t, farolPasto.Valor.Tipo)}`
      : "";
  const qualidade = farolPasto.Valor.QualidadeCapim
    ? " \n " + t("common:quality") + ": " + farolPasto.Valor.QualidadeCapim
    : "";
  return (
    textoToolTip +
    dataColeta +
    tipoFarol +
    " \n " +
    numeroTruncado.toString() +
    " cm" +
    qualidade
  );
};

const tranformaSeparacaoDoDecimalParaVirgula = (numero) => {
  numero = numero.toString().replace(".", ",");
  return numero;
};

export const montaTextoTooltipSanidade = (
  textoToolTip,
  farolPasto,
  categoriasLotes,
  idFarolSelecionado,
) => {
  let lotesDoPasto = "";
  if (farolPasto) {
    _.forEach(farolPasto.Valor.Lote, (lote) => {
      const categoria = _.find(
        categoriasLotes,
        (categoria) => categoria.IdCategoriaAnimal === lote.IdCategoriaAnimal,
      );
      if (categoria) {
        const stringValor = lote.Valor
          ? t("common:actions.yes")
          : t("common:actions.no");

        lotesDoPasto = `\
          ${lotesDoPasto}${categoria.Nome.toUpperCase()}\
          - ${t("common:collect-date")}: ${lote.DataColeta}
          - ${stringSanidade[idFarolSelecionado]} ${stringValor}`;
        if (lote.Quantidade > 0)
          lotesDoPasto = `${lotesDoPasto} - ${t(
            "common:quantity-abreviation",
          )}: ${lote.Quantidade}`;
        lotesDoPasto += `\n`;
      }
    });

    textoToolTip = `${textoToolTip}\n${lotesDoPasto}`;
  }
  return textoToolTip;
};

const formataTextoTooltipGanhoPeso = (lote, percentual, status) => {
  const dataFormatada = lote.DataPesagemVisual
    ? moment(lote.DataPesagemVisual).format("DD/MM/YYYY")
    : "N/A";
  const pesoVisualTratado = lote.PesoVisual ? `${lote.PesoVisual} KG` : "N/A";
  const pesoProjetadoTratado = lote.PesoProjetado
    ? `${lote.PesoProjetado.toFixed(2)} KG`
    : "N/A";
  const textoToolTip = `\n${t("animalCategory:category")}: ${
    lote.Categoria.Nome
  }
  ${t("livestock:visual-weight")}: ${pesoVisualTratado}
  ${t("statusIndicator:projected-weight")}: ${pesoProjetadoTratado}
  ${t("statusIndicator:date-of-visual-weight")}: ${dataFormatada}
  ${t("statusIndicator:percent-of-projected-weight", {
    percent: percentual,
    status,
  })}`;
  return textoToolTip;
};

export const montaTextoTooltipGanhoPeso = (farolPasto) => {
  let detalhesDoPasto = `\n${t("statusIndicator:pasture-without-reference")}`;

  if (farolPasto && farolPasto.Lotes.length > 0) {
    farolPasto.Lotes.forEach((lote) => {
      let loteExibido = { Percentual: farolPasto.Lotes[0].Percentual };
      let detalhesDoLote;
      const percentual = Math.round(lote.Percentual);
      if (percentual >= 10) {
        detalhesDoLote = formataTextoTooltipGanhoPeso(
          lote,
          percentual,
          "acima",
        );
      }
      if (percentual < 10 && percentual >= -10) {
        detalhesDoLote = formataTextoTooltipGanhoPeso(
          lote,
          percentual,
          "esperado",
        );
      }
      if (percentual < -10) {
        detalhesDoLote = formataTextoTooltipGanhoPeso(
          lote,
          percentual,
          "abaixo",
        );
      }
      if (lote.Percentual <= loteExibido.Percentual) {
        detalhesDoPasto = detalhesDoLote;
        loteExibido = { ...lote };
      }
    });
  } else if (farolPasto && farolPasto.Lotes.length === 0) {
    detalhesDoPasto = t("statusIndicator:pasture-without-visual-measure");
  }
  return detalhesDoPasto;
};

export const montaTextoTooltipVoltagem = (farolPasto) => {
  let textoToolTip = "";
  if (farolPasto && farolPasto.Cor) {
    const { Valor } = farolPasto;
    textoToolTip = Valor
      ? `\n${t("statusIndicator:voltage-value", { value: Valor })}`
      : "";
  }
  return textoToolTip;
};

export const montaTextoTooltipEntreveiro = (farolPasto) => {
  let textoToolTip = "";
  if (farolPasto && farolPasto.Valor && farolPasto.Valor.length) {
    farolPasto.Valor.forEach((entrevero) => {
      const { Quantidade, Categoria, Data } = entrevero;
      textoToolTip = `${textoToolTip} \n ${Quantidade} ${Categoria}\n ${Data}`;
    });
  }
  return textoToolTip;
};

export default InfoFarol;
